<template>
  <div>
    <article class="resort-item resort-item-large">
      <search-item-images :resort="resort" />

      <a
        :href="resort.__platform_url + searchParams"
        target="_blank"
        class="relative"
      >
        <div class="price-cta">
          <div v-if="validOffers.length" class="flex justify-end gap-1">
            <span
              v-for="(offer, index) in validOffers.slice(0, 1)"
              :key="index"
              class="discount-tag"
              :class="getOfferClass(offer)"
            >
              {{ offer.discountTag }}
            </span>
          </div>

          <div class="fs-16 my-2" v-if="resort.__odyssey_price">
            <span class="fs-20 font-medium leading-tight">
              <currency-context>
                <template v-slot="{ convert }">
                  <span v-text="convert(resort.__odyssey_price)"></span>
                </template>
              </currency-context>
            </span>
            /night
          </div>
          <button class="btn btn-primary">View resort</button>
        </div>

        <h4 class="fs-20 font-medium flex items-center">
          <span v-html="resort.__platform_name" />
          <booking-term-icon
            v-if="hasBookingTerm"
            :type="bookingTerm.type"
            class="ml-2 fill-blue"
          />
        </h4>

        <p
          class="mt-1 text-black-light-5 fs-14"
          v-html="resort.__platform_destination_title"
        ></p>

        <div class="mt-2 flex items-end" v-if="!!resort.rating">
          <rating
            :value="resort.rating.supplier_rating"
            class="mr-1"
            size="28"
          />
          <span class="fs-14 text-black-light-5"
            >{{ resort.rating.count }}
            {{ resort.rating.count > 1 ? "reviews" : "review" }}</span
          >
        </div>

        <div class="flex items-center price-info mt-2" v-else>
          <div class="flex items-center flex-1">
            <template v-if="resort.__platform_rating">
              <img
                :src="tripadvisorImage"
                :alt="resort.__platform_name"
                width="119"
                height="20"
                class="review-image max-w-none"
              />
              <a
                :href="resort.__platform_tripadvisor_url"
                class="review-text underline text-black-light-5 text-sm leading-none"
              >
                <span
                  >{{
                    resort.__platform_tripadvisor_total_review
                  }}
                  reviews</span
                >
              </a>
            </template>
          </div>
        </div>

        <div v-if="displayingFacilities.length" class="text-black-light-5 mt-4">
          <ul class="list-reset flex items-center flex-wrap">
            <li
              v-for="(item, index) in displayingFacilities"
              :key="index"
              class="mr-2 has-tooltip"
            >
              <span class="tooltip rounded shadow-lg py-1 px-4 fs-16">{{
                item.name
              }}</span>
              <img width="28" height="28" :src="item.icon" :alt="item.name" />
            </li>
          </ul>
        </div>

        <p :class="displayingFacilities.length ? 'mt-4' : 'mt-10'">
          {{ resort.__platform_description }}
        </p>

        <div
          class="mt-4"
          v-if="
            resort.__odyssey_greenfins_membership_level ||
              resort.__odyssey_zublu_featured
          "
        >
          <div
            v-if="resort.__odyssey_greenfins_membership_level !== 'none'"
            class="greenfin-tag mr-2 capitalize"
            :class="`${resort.__odyssey_greenfins_membership_level}-color`"
          >
            Green Fins {{ resort.__odyssey_greenfins_membership_level }} Member
          </div>
          <div v-if="resort.__odyssey_zublu_featured" class="top-pick-tag mr-2">
            Our top pick
          </div>
        </div>
      </a>
    </article>
  </div>
</template>

<script>
import get from "lodash/get";
import ResortItemMixin from "../../mixins/ResortItemMixin";
import SearchItemImages from "./SearchItemImages";
import BookingTermIcon from "./mixins/BookingTermIcon";
import Rating from "../core/Rating";
import CurrencyContext from "../core/CurrencyContext";

export default {
  components: { Rating, BookingTermIcon, SearchItemImages, CurrencyContext },
  mixins: [ResortItemMixin],
  props: ["resort"],
  computed: {
    hasBookingTerm() {
      return typeof this.resort.__odyssey_booking_terms === "object";
    },
    bookingTerm() {
      return this.hasBookingTerm ? this.resort.__odyssey_booking_terms : {};
    },
    searchParams() {
      return window.location.search;
    },
  },
};
</script>

<style scoped>
.resort-item .price-cta {
  position: absolute;
  top: 0;
  right: 0;
  text-align: right;
}

.discount-tag {
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 4px;
}
</style>
